import { useEffect } from "react";
import { CONSENT_EVENT, readConsent, type CookieConsent } from "@/lib/cookie-consent";

export const OPENAI_PIXEL_ID = "KjcZqAfwKqw4tHFF9XRudm";

type OaiqFn = ((...args: unknown[]) => void) & { q?: unknown[] };

/**
 * Pixel de anúncios do ChatGPT (OpenAI). Carregado apenas após consentimento
 * de marketing (LGPD), idempotente e seguro em SSR.
 */
export function OpenAiPixel({ pixelId = OPENAI_PIXEL_ID }: { pixelId?: string }) {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const w = window as unknown as {
      oaiq?: OaiqFn;
      __kentroOaiqInit?: Record<string, boolean>;
    };

    const load = () => {
      w.__kentroOaiqInit = w.__kentroOaiqInit || {};
      if (!w.oaiq) {
        const q: OaiqFn = function (...args: unknown[]) {
          q.q!.push(args);
        } as OaiqFn;
        q.q = [];
        w.oaiq = q;
        const j = document.createElement("script");
        j.async = true;
        j.src = "https://bzrcdn.openai.com/sdk/oaiq.min.js";
        const f = document.getElementsByTagName("script")[0];
        f?.parentNode?.insertBefore(j, f);
      }
      if (!w.__kentroOaiqInit[pixelId]) {
        const debug = new URLSearchParams(window.location.search).has("oaiq_debug");
        w.oaiq?.("init", { pixelId, debug });
        w.__kentroOaiqInit[pixelId] = true;
        // Reprocessa conversões que ocorreram antes do consentimento/carregamento.
        try {
          const pending = JSON.parse(
            window.sessionStorage.getItem("kentro-oaiq-pending") || "[]",
          ) as Array<{ event: string; data?: Record<string, unknown> }>;
          for (const p of pending) {
            w.oaiq?.("measure", p.event, p.data ?? { type: "customer_action" });
          }
          window.sessionStorage.removeItem("kentro-oaiq-pending");
        } catch {
          /* noop */
        }
      }
    };

    if (readConsent()?.marketing) load();

    const onChange = (e: Event) => {
      const detail = (e as CustomEvent<CookieConsent>).detail;
      if (detail?.marketing) load();
    };
    window.addEventListener(CONSENT_EVENT, onChange as EventListener);
    return () => window.removeEventListener(CONSENT_EVENT, onChange as EventListener);
  }, [pixelId]);

  return null;
}
